import { render } from "./AboutCards.vue?vue&type=template&id=00e89ec2&scoped=true"
import script from "./AboutCards.vue?vue&type=script&lang=js"
export * from "./AboutCards.vue?vue&type=script&lang=js"

import "./AboutCards.vue?vue&type=style&index=0&id=00e89ec2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00e89ec2"]])

export default __exports__